import config from "../../config.js";
import RequestManager from "../request.js";

export default class ChoixBenec {
    // Base URI alignée avec [RoutePrefix("api/cartevitale")]
    // (si config.urlBackEnd se termine déjà par "api/", alors "cartevitale" donnera "api/cartevitale")
    // GETTER (evalue a chaque acces) et NON champ statique fige a l'import : sinon l'URI
    // reste collee sur /backend/ et ignore la bascule vers /final/ apres login (cf ErreurAffichable).
    static get uri() { return config.urlBackEnd + "cartevitale"; }

    /**
     * Récupère la valeur actuelle de benec
     * GET /api/cartevitale/choix-benec/
     */
    static async getBenec() {
        return RequestManager.get(`${this.uri}/choix-benec/`)
            .then(response => {
                // Le contrôleur renvoie un nombre brut (short) via Ok(...)
                // On normalise au cas où un jour la réponse devienne { benec: x }
                if (typeof response === "number") return response;
                if (response && typeof response.benec !== "undefined") return response.benec;
                return response;
            })
            .catch(error => {
                console.error("ChoixBenec.getBenec -->", error);
                throw error;
            });
    }

    /**
     * Modifie benec (version route param)
     * POST /api/cartevitale/choix-benec/{benec}
     */
    static async setBenec(benec) {
        try {
            const response = await RequestManager.post(
                `${this.uri}/choix-benec/${encodeURIComponent(benec)}`
            );
            return response; // { success: true, benec }
        } catch (error) {
            console.error("ChoixBenec.setBenec -->", error);
            throw error;
        }
    }

    /**
     * Modifie benec (version querystring)
     * POST /api/cartevitale/choix-benec?benec=2
     */
    static setBenecQuery(benec) {
        return RequestManager.post(`${this.uri}/choix-benec?benec=${encodeURIComponent(benec)}`)
            .then(response => response) // { success: true, benec }
            .catch(error => {
                console.error("ChoixBenec.setBenecQuery -->", error);
                throw error;
            });
    }
}
